import type { Finding } from "../contracts/types";

interface FindingsListProps {
  findings: Finding[];
}

export function FindingsList({ findings }: FindingsListProps) {
  if (findings.length === 0) {
    return <p className="empty-state">Sin hallazgos para este resultado.</p>;
  }
  return (
    <ul className="findings-list">
      {findings.map((finding, index) => (
        <li key={`${finding.ruleId}-${index}`} className={`severity-${finding.severity}`}>
          <span className={`state-badge state-badge--${finding.severity === "error" ? "error" : finding.severity}`}>
            {finding.severity}
          </span>{" "}
          <strong>{finding.ruleId}:</strong> {finding.message}
          {finding.suggestion ? <p className="field-hint">{finding.suggestion}</p> : null}
        </li>
      ))}
    </ul>
  );
}
